import { marked } from 'marked';

export const APPLICATION_NAME = 'YOUR_APPLICATION_NAME';
export const TOKEN_KEY = 'token';
export const baseAuth = 'amt1QDhlYWtoUzlTOjhyUzBnU0coVDQwKTlDaA==';

export const currencySymbols = {
  USD: '$',
  EUR: '€',
  CRC: '₡',
  GBP: '£',
  ILS: '₪',
  INR: '₹',
  JPY: '¥',
  KRW: '₩',
  NGN: '₦',
  PHP: '₱',
  PLN: 'zł',
  AUD: 'A$',
  CAD: 'C$',
  CHF: '₣',
  HKD: 'HK$',
  PYG: '₲',
  THB: '฿',
  UAH: '₴',
  VND: '₫',
};

export const currencyOptions = [
  { value: 'USD', label: 'USD' },
  { value: 'INR', label: 'INR' },
  { value: 'EUR', label: 'EUR' },
  { value: 'GBP', label: 'GBP' },
  { value: 'JPY', label: 'JPY' },
  { value: 'AUD', label: 'AUD' },
  { value: 'CAD', label: 'CAD' },
  { value: 'CHF', label: 'CHF' },
  { value: 'HKD', label: 'HKD' },
];

export const relativeRisOptions = [
  { value: 'High', label: 'High' },
  { value: 'Average', label: 'Average' },
  { value: 'Low', label: 'Low' },
];

export const unitOptions = [
  { value: 'Thousand', label: 'Thousand' },
  { value: 'Million', label: 'Million' },
  { value: 'Billion', label: 'Billion' },
  //{ value: 'Trillion', label: 'Trillion' },
];

export const languages = {
  english: 'ENG',
  hindi: 'HI',
};

export const defaultFundField = [
  {
    value: 'fund-details.inception_year',
    label: 'Inception Year',
  },
  {
    value: 'fund-details.size',
    label: 'Size',
  },
  {
    value: 'fund-details.max_fund_size',
    label: 'Max Size',
  },
  {
    value: 'fund-terms.investment_period',
    label: 'Investment Period',
  },
  {
    value: 'fund-terms.fund_duration',
    label: 'Duration',
  },
  {
    value: 'fund-terms.extension',
    label: 'Extension',
  },
  {
    value: 'fund-fees.Management Fee',
    label: 'Management Fee',
  },
  {
    value: 'fund-terms.carried_interest',
    label: 'Carried Interest',
  },
  {
    value: 'fund-terms.preferred_return',
    label: 'Preferred Return',
  },
  {
    value: 'fund-terms.gp_commitment',
    label: 'GP Commitment',
  },
];

export const reviewStatus = [
  'Initial Review',
  'Data Extraction',
  'Pending Review',
];

export const formatAmountMagnitude = ({ value }) => {
  if (!value) return '';
  const symbol =
    currencySymbols[value.substring(0, 3)] || value.substring(0, 3);
  const match = value
    .substring(3)
    .trim()
    .match(/^([\d,.]+)\s*([A-Za-z]*)$/);
  return match
    ? `${symbol} ${match?.[1]}${match?.[2]}`
    : `${symbol} ${value.substring(3).trim()}`;
};

export const parseMagnitudeAmount = (value) => {
  if (!value) return 0;

  const match = value.match(/([\d.,]+)\s*([KMB])/i);
  if (!match) return 0;

  const num = parseFloat(match[1].replace(/,/g, ''));
  const magnitude = match[2].toUpperCase();

  switch (magnitude) {
    case 'K':
      return num / 1_000; // thousands to millions
    case 'M':
      return num;
    case 'B':
      return num * 1_000;
    default:
      return 0;
  }
};

export const formatMillionAmount = (valueInMillions) => {
  if (!valueInMillions) return '$ 0';
  if (valueInMillions >= 1000)
    return `$ ${(valueInMillions / 1000).toFixed(1)}B`;
  if (valueInMillions < 1) return `$ ${(valueInMillions * 1000).toFixed(1)}K`;
  return `$ ${valueInMillions.toFixed(0)}M`;
};

// Only for truly mismatched section names
const specialSectionMap = {
  'fund-fees': 'Fees',
  'fund-assets': 'PortfolioCompanies',
};

const toPascalCase = (str) =>
  str
    .replace(/[-_]+/g, ' ')
    .replace(/\s(.)/g, (_, chr) => chr.toUpperCase())
    .replace(/^(.)/, (_, chr) => chr.toUpperCase())
    .replace(/\s+/g, '');

const findSectionForKey = (fundLlmConfig = [], key) => {
  if (!Array.isArray(fundLlmConfig) || !key) return null;
  for (const configEntry of fundLlmConfig) {
    if (!configEntry || typeof configEntry !== 'object') continue;
    const [sectionName, sectionData] = Object.entries(configEntry)[0];

    if (Array.isArray(sectionData)) {
      // Case: section is an array of objects
      for (const obj of sectionData) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          return sectionName;
        }
      }
    } else if (typeof sectionData === 'object' && sectionData?.values) {
      // Case: section has "values" array
      for (const obj of sectionData.values) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          return sectionName;
        }
      }
    }
  }
  return null;
};

export const getHoverDetail = (
  section,
  key,
  hoverDetails = {},
  fundLlmConfig = []
) => {
  const sectionsToCheck = Array.isArray(section) ? section : [section];

  for (const sec of sectionsToCheck) {
    const details = hoverDetails?.[sec]?.find(
      (item) => item?.row_name === key || item?.row_id === key
    );
    if (details) {
      return `${details.edited_by} on ${details.timestamp}`;
    }
  }

  const foundSectionName = findSectionForKey(fundLlmConfig, key);
  if (foundSectionName) {
    const hoverSectionName =
      specialSectionMap[foundSectionName] || toPascalCase(foundSectionName);

    const details = hoverDetails?.[hoverSectionName]?.find(
      (item) => item?.row_name === key || item?.row_id === key
    );
    if (details) {
      return `${details.edited_by} on ${details.timestamp}`;
    }
  }

  return null;
};

export const convertToHTML = (text) => {
  if (typeof text !== 'string') return '';

  let cleanedText = text.replace(/\\n/g, '\n').replace(/\n/g, '\n').trim();

  const embeddedTableRegex = /([^\n]*?):?\s*(\|.+\|[\r\n]+\|[-| ]+\|[\s\S]*)/;
  const embeddedMatch = cleanedText.match(embeddedTableRegex);

  if (embeddedMatch) {
    const prefix = embeddedMatch[1]?.trim();
    const tableContent = embeddedMatch[2]?.trim();
    cleanedText = (prefix ? `${prefix}:\n\n` : '') + tableContent;
  }

  if (
    cleanedText.trim().startsWith('|') &&
    /\|(.+?)\|/.test(cleanedText) &&
    /[-|]{3,}/.test(cleanedText) &&
    !/^\n/.test(cleanedText)
  ) {
    cleanedText = '\n' + cleanedText;
  }

  const isMarkdownTable =
    /\|(.+?)\|/.test(cleanedText) && /[-|]{3,}/.test(cleanedText);

  if (isMarkdownTable) {
    // Remove # at the start of table header cell values (first row only)
    cleanedText = cleanedText.replace(
      /^(\|.*\|)$/m,
      (headerRow) => headerRow.replace(/(\|\s*)#\s*/g, '$1') // removes "# " after |
    );

    // Escape # symbols from all other table cells (optional, if needed)
    cleanedText = cleanedText.replace(/^(\|.*)$/gm, (row) =>
      row.replace(/(?<=\|[^#\n]*)#(?=[^|]*\|)/g, '&#35;')
    );

    // Ensure parser detects table
    if (!/^\n/.test(cleanedText.trim())) {
      cleanedText = '\n' + cleanedText;
    }
  }

  const isBoldBulletList = /^(\s*[-*] \*\*.+?\*\*.*)/m.test(cleanedText);

  // Detect plain markdown bullet list
  const isPlainBulletList =
    /^(\s*[-*] .+)/m.test(cleanedText) &&
    !/<li>|<\/li>|<ul>|<\/ul>/.test(cleanedText); // avoid reprocessed HTML

  if (isMarkdownTable || isBoldBulletList || isPlainBulletList) {
    // Use pure markdown processing for tables without additional formatting
    return marked(cleanedText);
  }

  cleanedText = cleanedText.replace(/\n\*+/g, '<ul>$&</ul>* ');
  cleanedText = cleanedText.replace(/\n●/g, '<br>● ');
  cleanedText = cleanedText.replace(/\n/g, ' '); // Replace remaining newlines with space

  let modifiedHTML = marked(cleanedText); // Convert Markdown to HTML
  modifiedHTML = modifiedHTML.replace(//g, '<li>');
  modifiedHTML = modifiedHTML.replace(/<li>([\s\S]+?)<\/li>/g, '<ul>$&</ul>');
  modifiedHTML = modifiedHTML.replace(
    /<h2>(.*?)<\/h2>/g,
    '<h2 class="custom-h2">$1</h2>'
  );

  return modifiedHTML;
};

export const getSortedFundDetails = (fieldOrderConfig, fundDetail) => {
  return fieldOrderConfig
    ? [...fieldOrderConfig]
        .sort((a, b) => a.order - b.order) // Sort by order
        .map(({ key }) => {
          const foundInFundDetails = fundDetail.find(
            (detail) => detail && detail[key] !== undefined
          );
          return foundInFundDetails || { [key]: 'N/A' }; // Return 'N/A' if key not found
        })
        .filter(Boolean) // Filter out undefined or null values
    : [];
};
